import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

function Home({ language, t }) {
  const [hoveredCard, setHoveredCard] = useState(null);

  const practiceAreas = [
    { icon: '👨‍👩‍👧‍👦', title: t.familyLaw, desc: t.familyLawDesc },
    { icon: '💼', title: t.laborLaw, desc: t.laborLawDesc },
    { icon: '📋', title: t.laborExpert, desc: t.laborExpertDesc, to: '/is-hukuku-bilirkisi' },
    { icon: '🏢', title: t.commercialLaw, desc: t.commercialLawDesc },
    { icon: '🏠', title: t.realEstateLaw, desc: t.realEstateLawDesc },
    { icon: '⚖️', title: t.bankruptcyLaw, desc: t.bankruptcyLawDesc },
    { icon: '⚔️', title: t.criminalLaw, desc: t.criminalLawDesc },
    { icon: '🛡️', title: t.consumerLaw, desc: t.consumerLawDesc },
    { icon: '📝', title: t.contractLaw, desc: t.contractLawDesc },
    { icon: '💰', title: t.inheritanceLaw, desc: t.inheritanceLawDesc },
    { icon: '🔑', title: t.rentalLaw, desc: t.rentalLawDesc },
    { icon: '📊', title: t.taxLaw, desc: t.taxLawDesc },
    { icon: '💻', title: t.itLaw, desc: t.itLawDesc },
  ];

  const isArabic = language === 'ar';

  return (
    <main className="home">
      <SEO
        title="TAMA & ORAL Hukuk Bürosu - İzmir Avukat | İcra, Hukuki Danışmanlık"
        description="TAMA & ORAL Hukuk Bürosu - İzmir'de profesyonel avukat hizmetleri. İcra takibi, aile hukuku, ticari hukuk, gayrimenkul hukuku ve daha fazlası. Profesyonel hukuki danışmanlık."
        keywords="avukat izmir, icra, hukuk bürosu, hukuki danışman, gayrimenkul hukuku, ticari hukuk, aile hukuku, vergi hukuku, bayraklı izmir, iş hukuku bilirkişisi, iş hukuku bilirkişi, iş davası bilirkişi"
        canonical="https://tamaoral.av.tr/"
      />
      <section className="hero">
        <div className="hero-content">
          <div className="hero-decoration">✦</div>
          <h1 className="hero-title">TAMA & ORAL</h1>
          <h2 className="hero-subtitle">{t.firmSubtitle}</h2>
          <p className="tagline">{t.motto}</p>
          <div className="quote-container">
            <div className="quote-mark">"</div>
            <p className="quote">
              {t.lawyerQuote}
            </p>
            <div className="quote-mark closing">"</div>
          </div>
        </div>
        <div className="hero-background">
          <div className="blob blob-1"></div>
          <div className="blob blob-2"></div>
          <div className="blob blob-3"></div>
        </div>
      </section>

      <section className="practice-areas">
        <div className="section-header">
          <h2>{t.serviceAreas}</h2>
          <p className="section-subtitle">{t.comprehensiveSolutions}</p>
        </div>
        <div className="areas-grid">
          {practiceAreas.map((area, index) => (
            <div
              key={index}
              className="area-card"
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              dir={isArabic ? 'rtl' : 'ltr'}
            >
              <div className="area-icon">{area.icon}</div>
              <h3>{area.title}</h3>
              <p>{area.desc}</p>
              {area.to && (
                <Link to={area.to} className="area-link">{t.readMore} →</Link>
              )}
              <div className={`card-line ${hoveredCard === index ? 'active' : ''}`}></div>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-content">
          <h2>{t.needConsultation}</h2>
          <p>{t.teamReady}</p>
          <Link to="/contact" className="cta-button">
            <span>{t.contactUs}</span>
            <span className="button-arrow">{isArabic ? '←' : '→'}</span>
          </Link>
        </div>
        <div className="cta-decoration">
          <div className="cta-shape"></div>
        </div>
      </section>
    </main>
  );
}

export default Home;
